module.exports = __webpack_public_path__ + "static/img/titthai.d98f873.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/entry/img/titthai.png
// module id = 6PeM
// module chunks = 1